import apiConfig from "../../utils/config.json";
import httpService from "../httpService";

const apiEndPoint = `${apiConfig.apiUrl}dpStaff/get/todayNotWorkingPcsInCenter`;

export function getNotMarkedPCs(centerId, value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {}
  };
  return httpService.post(`${apiEndPoint}/${centerId}`, obj);
}

export default {
  getNotMarkedPCs,
};